import { Routes } from '@angular/router';
import { mySuppliesGuard, userGuard } from '@core/guards';
import { PageTitleEnum } from '@shared/enums';

export const suppliesRoutes: Routes = [
    {
        path: '',
        loadComponent: () =>
            import('./_supplies-layout/supplies-layout.component').then(mod => mod.SuppliesLayoutComponent),
        canActivate: [userGuard],
        children: [
            {
                path: '',
                redirectTo: 'overview',
                pathMatch: 'full',
            },
            {
                path: 'overview',
                loadComponent: () =>
                    import('./supplies-overview/supplies-overview.component').then(
                        mod => mod.SuppliesOverviewComponent
                    ),
                canActivate: [mySuppliesGuard],
                title: PageTitleEnum.SUPPLIES_OVERVIEW,
            },
            {
                path: 'request-supplies',
                loadComponent: () =>
                    import('./request-supplies/request-supplies.component').then(mod => mod.RequestSuppliesComponent),
                canActivate: [mySuppliesGuard],
                title: PageTitleEnum.SUPPLIES_REQUEST,
            },
            {
                path: 'faq',
                loadComponent: () => import('./supply-faq/supply-faq.component').then(mod => mod.SupplyFaqComponent),
                canActivate: [mySuppliesGuard],
                title: PageTitleEnum.SUPPLIES_FAQ,
            },
        ],
    },
];
